import React from 'react'
import BottomNav from './components/BottomNav';
import logo from "./assets/images/cc-logo.png";
import avatar from "./assets/images/avatar.jpg"

export default function ProfilePage() {



  return (
    <div className="assets-panel bg-[#242626] min-h-[100vh] ">
        <div className="containerx text-white">
        <img src={logo} className="py-7 w-48" alt="" />
        <p className="text-[#6c6c6c] mb-2">profile</p>

                  <div className="profile-core flex gap-4 items-center">
                    
                    <img className='w-16 rounded-full' src={avatar} alt="" />
                    <div className="profile-data">
                      <h3 className='text-xl font-bold'>Samuel Miller</h3>
                      <p className='text-zinc-400 text-sm'>@samuelm.eth</p>
                    </div>
                  </div>
                  </div>
        <BottomNav />
      </div>
  )
}
